import * as React from 'react'

export const SVG_Plus = () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5233 7.01178C13.5233 7.64125 13.0131 8.15138 12.3833 8.15138H8.1511V12.3837C8.1511 13.0133 7.64078 13.5234 7.01139 13.5233C6.69663 13.5233 6.41173 13.3959 6.20569 13.1897C5.99938 12.9833 5.87185 12.6985 5.87199 12.384L5.87182 8.15121H1.63911C1.32456 8.15121 1.03988 8.02384 0.833412 7.81738C0.62745 7.61142 0.5 7.32653 0.5 7.01178C0.49983 6.38243 1.00997 5.87219 1.63971 5.87219H5.87199V1.63985C5.87199 1.0103 6.38242 0.5 7.01187 0.5C7.6411 0.50017 8.15107 1.00996 8.15141 1.63942V5.87219H12.3841C13.0135 5.87253 13.5229 6.38243 13.5233 7.01178Z"
            fill="currentColor"
        />
    </svg>
)
